<div class="mode-switch">
	<button class="btn-2d" [class.selected]="currentViewMode === VIEW_MODE.M2D"
		(click)="onViewChange(VIEW_MODE.M2D)">2D</button>
	<button class="btn-3d" [class.selected]="currentViewMode === VIEW_MODE.M3D" [disabled]="!readyForRender"
		(click)="onViewChange(VIEW_MODE.M3D)">3D</button>
</div>

<!-- Barra de herramientas -->
<div id="idToolBar" [hidden]="UIHidden()" class="tool-box">
	<div class="tool-box-header" (click)="handleState()" [class.disabled]="disabledToolBox">
		<i class="fa fa-angle-{{ minimized ? 'right': 'left' }} fa-rotate-90"></i>
	</div>
	<!-- Iconos de las opciones -->
	<div class="tool-box-contents">
		<!-- NO EDICION -->
		<button class="btn-tool-box" [class.selected]="ModeDrag()" (click)="drawDragMode();">
			<i class="fa fa-hand-paper-o fa-2x" alt="Movimiento de cámara"></i>
		</button>
		<!-- EDITAR -->
		<button class="btn-tool-box" [hidden]="UIMinimize()" [class.selected]="ModeDraw()" (click)="drawDrawMode();">
			<i class="fa fa-pencil fa-2x"></i>
		</button>
		<!-- PUERTAS -->
		<button class="btn-tool-box png" [hidden]="UIMinimize()" [disabled]="!canDoor()" [class.selected]="ModeDoor()" (click)="drawDoorMode();">
			<img src="assets/img/door_w.png" alt="Añadir puerta" />
		</button>
		<div class="ruler" [hidden]="UIMinimize()"></div>
		<!-- DESHACER -->
		<button class="btn-tool-box" [hidden]="UIMinimize()" [disabled]="!canHistorialBack()" (click)="clickUndo();">
			<i class="fa fa-reply fa-2x"></i>
		</button>
		<!-- REHACER -->
		<button class="btn-tool-box" [hidden]="UIMinimize()" [disabled]="!canHistorialNext()" (click)="clickRedo();">
			<i class="fa fa-reply fa-2x fa-flip-horizontal"></i>
		</button>
		<div class="ruler" [hidden]="UIMinimize()"></div>
		<!-- BORRAR OBJETO -->
		<button class="btn-tool-box" [hidden]="UIMinimize()" [class.selected]="ModeErase()" [disabled]="btnEraseAll()" (click)="drawEraseMode();">
			<i class="fa fa-eraser fa-2x"></i>
		</button>
		<!-- BORRAR TODO -->
		<button class="btn-tool-box" [hidden]="UIMinimize()" [disabled]="btnEraseAll()" (click)="drawEraseAllMode()">
			<i class="fa fa-trash fa-2x"></i>
		</button>
	</div>
</div>

<div id='idSearchBoxClass' [hidden]="!searchBoxVisibled">
	<input places-auto-complete #searchBox id="idSearchBox" [(ngModel)]="searchString"
		[disabled]="isDisabled === true" placeholder=" {{ modelService.getString('searchbox_placeholer') }}" />
	<i *ngIf="searchString == ''" class="fa fa-search"></i>
	<i *ngIf="searchString != ''" class="fa fa-times" (click)="searchString=''"></i>
</div>

<app-settingsbox #settingsBox *ngIf="currentViewMode === VIEW_MODE.M2D" [projectData]="projectData"
	[currentPerimeter]="getCurrentPerimeter()" (onSave)="saveLocal()" [isDisabled]="projectData.estado > 0">
</app-settingsbox>

<div id="idControlZoom" [hidden]="UIHidden()">
	<button class="btn-plus btnZoom" (click)="onZoomChange(-1)"><i class="fa fa-plus"></i></button>
	<button class="btn-less btnZoom" (click)="onZoomChange(1)"><i class="fa fa-minus"></i></button>
</div>

<!-- Botón ver detalle del proyecto (presupuesto) -->
<div class="app-see-box {{currentViewMode}}"
	[class.minimized]="isMinimized"
	[class.open]="!isMinimized">
	<div class="app-see-box-header" (click)="handleStateSee()">
		<i class="fa fa-angle-{{ isMinimized ? 'left': 'right' }}"></i>
	</div>
	<div class="app-see-box-contents">
		<button class="open-btn" [disabled]="!readyForRender" (click)="sendForAproval()">
			<span *ngIf="!isMinimized" class="label">{{ modelService.getString('builder_view_detail') }}</span>
			<i class="fa fa-eye fa-2x"></i>
		</button>
	</div>
</div>

<div id="idControlFullScreen" [hidden]="UIHidden()">
	<button class="btn-plus btnZoom" (click)="onToggleChange()">
		<i class="{{!fullscreen? 'fa fa-expand' : 'fa fa-compress'}}"></i>
	</button>
</div>

<google-map #gmap id="idMap" *ngIf="currentViewMode === VIEW_MODE.M2D" style="width: 100%; height: 100%;"></google-map>
<app-satelite3d *ngIf="currentViewMode === VIEW_MODE.M3D" [projectData]="projectData" (onFinish3DOK)="onFinish3DOK()" (onFinish3DKO)="onFinish3DKO()">
</app-satelite3d>
<!-- <app-scheme3d *ngIf="currentViewMode === VIEW_MODE.M3D" [projectData]="projectData"></app-scheme3d> -->

<div class="label-container total-distance" *ngIf="currentViewMode === VIEW_MODE.M2D"
	[class.canvas-fullscreen]="fullscreen" [class.canvas-screen]="!fullscreen"
	[class.is--3d]="currentViewMode === VIEW_MODE.M3D">
	<span class="truncate-text">{{ modelService.getString('builder_length') }}</span>: <span class="value"
		[class.error]="totalLengthErr" style="text-align:right">{{ totalLengthStr }} m</span>
</div>

<!--div id="idFooter" class="controlbar" *ngIf="!fullscreen">
	<div class="project-status">{{ modelService.getString('builder _status') }}: {{ projectData.estado.toString() | projectStatusPipe }}</div>
	<button class="btn btn-default" [disabled]="!readyForRender" (click)="send ForAproval()">{{ modelService.getString('builder_ view_detail') }}</button>
</div-->
<app-new-project #newProjectWindow></app-new-project>
<app-loader #loader *ngIf="loading"></app-loader>
<app-alert #alertWindow ></app-alert>


